export default {"src":"/_next/static/media/circle.965ca731.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};